module.exports = __webpack_public_path__ + "img/detail-category.2a8f74a2.svg";